import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { pageTitle } from '../../helper';
import 'swiper/css';
import 'swiper/css/pagination';
import Hero6 from '../Hero/Hero6';
import { Icon } from '@iconify/react';
import Slider from 'react-slick';
import Portfolio from '../Portfolio';
import Div from '../Div'
import Cta from '../Cta';
import SectionHeading from '../SectionHeading'
import TestimonialSlider from '../Slider/TestimonialSlider'
import Spacing from '../Spacing'
// import PortfolioSlider2 from '../Slider/PortfolioSlider2';
import VerticalLinks from '../VerticalLinks';
import '../../components/ServiceList/servicelist.scss';
import parse from 'html-react-parser';

const portfolioData = [
    {
        title: 'Colorful Art Work',
        subtitle: 'See Details',
        href: '/portfolio',
        src: '/images/ccs1.png',
    },
    {
        title: 'Colorful Art Work',
        subtitle: 'See Details',
        href: '/portfolio',
        src: '/images/ccs3.png',
    },
    {
        title: 'Colorful Art Work',
        subtitle: 'See Details',
        href: '/portfolio',
        src: '/images/ccs2.png',
    },
    {
        title: 'Colorful Art Work',
        subtitle: 'See Details',
        href: '/portfolio',
        src: '/images/ccs4.png',
    },
    {
        title: 'Colorful Art Work',
        subtitle: 'See Details',
        href: '/portfolio',
        src: '/images/ccs6.png',
    },
    {
        title: 'Colorful Art Work',
        subtitle: 'See Details',
        href: '/portfolio',
        src: '/images/ccs9.png',
    },
    {
        title: 'Colorful Art Work',
        subtitle: 'See Details',
        href: '/portfolio',
        src: '/images/ccs7.png',
    },
    {
        title: 'Colorful Art Work',
        subtitle: 'See Details',
        href: '/portfolio',
        src: '/images/ccs10.png',
    },
    {
        title: 'Colorful Art Work',
        subtitle: 'See Details',
        href: '/portfolio',
        src: '/images/ccs5.png',
    },
    {
        title: 'Colorful Art Work',
        subtitle: 'See Details',
        href: '/portfolio',
        src: '/images/ccs8.png',
    },
];



const PortfolioSlider2 = () => {
    /** Slider Settings **/
    const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
        <div
            {...props}
            className={
                'slick-prev slick-arrow' + (currentSlide === 0 ? ' slick-disabled' : '')
            }
            aria-hidden="true"
            aria-disabled={currentSlide === 0 ? true : false}
        >
            <Icon icon="bi:arrow-left" />
        </div>
    );
    const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
        <div
            {...props}
            className={
                'slick-next slick-arrow' +
                (currentSlide === slideCount - 1 ? ' slick-disabled' : '')
            }
            aria-hidden="true"
            aria-disabled={currentSlide === slideCount - 1 ? true : false}
        >
            <Icon icon="bi:arrow-right" />
        </div>
    );
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: <SlickArrowLeft />,
        nextArrow: <SlickArrowRight />,
        // Added autoplay settings
        autoplay: true,
        autoplaySpeed: 2000,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    dots: true,
                    arrows: false,
                },
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                    arrows: false,
                },
            },
        ],
    };

    return (
        <Slider {...settings} className="cs-gap-12 cs-arrow_style4">
            {portfolioData.map((item, index) => (
                <Div key={index}>
                    <Portfolio
                        title={item.title}
                        subtitle={item.subtitle}
                        href={item.href}
                        src={item.src}
                        variant="cs-style1 cs-type2 cs-size3"
                    />
                </Div>
            ))}
        </Slider>
    );
}

const heroSocialLinks = [
    {
        name: 'Instagram',
        links: 'https://www.instagram.com/justchargemedia/',
    },
    {
        name: 'Linkedin',
        links: 'https://www.linkedin.com/company/justchargemedia/posts/?feedView=all',
    },
];

const serviceData = [
    {
        title: 'Strategy & Research',
        subtitle:
            'Understanding audience behavior & trends.',
        imgUrl: '/images/cc1.png',
        href: '/service',
    },
    {
        title: 'Content Ideation',
        subtitle:
            'Developing creative concepts that align with brand goals.',
        imgUrl: '/images/cc2.png',
        href: '/service',
    },
    {
        title: 'Production',
        subtitle:
            'High-quality videos, reels, blogs, and visuals.',
        imgUrl: '/images/portfolio_37.png',
        href: '/service',
    },
    {
        title: 'Optimization',
        subtitle:
            'Ensuring content is SEO-friendly & engaging.',
        imgUrl: '/images/cc4.png',
        href: '/service',
    },
    {
        title: 'Distribution & Analysis',
        subtitle:
            'Tracking performance for future content strategies.',
        imgUrl: '/images/cc5.png',
        href: '/service',
    },
];

const ServiceList = ({ variant }) => {
    const [active, setActive] = useState(0);
    const handelActive = index => {
        setActive(index);
    };
    return (
        <Div className={`cs-iconbox_3_list ${variant ? variant : ''}`}>
            {serviceData.map((item, index) => (
                <Div
                    className={`cs-hover_tab ${active === index ? 'active' : ''}`}
                    key={index}
                    onMouseEnter={() => handelActive(index)}
                >
                    <Link to={item.href} className="cs-iconbox cs-style3">
                        <>
                            <Div className="cs-image_layer cs-style1 cs-size_md">
                                <Div className="cs-image_layer_in">
                                    <img
                                        src={item.imgUrl}
                                        alt="Thumb"
                                        className="w-100 cs-radius_15"
                                    />
                                </Div>
                            </Div>
                            <span className="cs-iconbox_icon cs-center">
                                <svg
                                    width={30}
                                    height={29}
                                    viewBox="0 0 30 29"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M29.3803 3.05172C29.4089 1.94752 28.537 1.02921 27.4328 1.00062L9.43879 0.534749C8.33459 0.506159 7.41628 1.37811 7.38769 2.48231C7.35911 3.58651 8.23106 4.50482 9.33526 4.53341L25.3299 4.94752L24.9158 20.9422C24.8872 22.0464 25.7592 22.9647 26.8634 22.9933C27.9676 23.0218 28.8859 22.1499 28.9144 21.0457L29.3803 3.05172ZM3.37714 28.5502L28.7581 4.4503L26.0039 1.54961L0.622863 25.6495L3.37714 28.5502Z"
                                        fill="currentColor"
                                    />
                                </svg>
                            </span>
                            <Div className="cs-iconbox_in">
                                <h2 className="cs-iconbox_title">{item.title}</h2>
                                <Div className="cs-iconbox_subtitle">{item.subtitle}</Div>
                            </Div>
                        </>
                    </Link>
                </Div>
            ))}
        </Div>
    );
};


const accordionData = [
    {
        question: 'What types of content do you create?',
        answer:
            'From high-quality brand films, product shoots, and social media content to 360-degree ad campaigns, we create engaging visuals that make your brand stand out.',
    },
    {
        question: 'Do you provide scriptwriting and creative direction?',
        answer:
            'Yes! We handle everything—from ideation and scripting to execution—ensuring every piece of content aligns with your brand message.',
    },
    {
        question: 'How do I know what type of content will work for my brand?',
        answer:
            'We analyze your audience, industry trends, and competitors to create content strategies that maximize impact. Whether it’s reels, ads, or long-form storytelling, we tailor it to your goals.',
    },
    {
        question: 'Can you create viral content for social media?',
        answer:
            'While virality isn’t guaranteed, our strategic approach maximizes shareability by focusing on emotions, trends, and compelling storytelling.',
    },
    {
        question: 'What’s your turnaround time for content production?',
        answer:
            'It depends on the project scope—short-form videos can take 5-7 days, while larger campaigns may require 2-4 weeks.',
    },
];

const CustomAccordion = () => {
    const [selected, setSelected] = React.useState(null);
    const handelToggle = index => {
        if (selected === index) {
            return setSelected(null);
        }
        setSelected(index);
    };

    return (
        <Div className="cs-accordians cs-style1">
            {accordionData.map((item, index) => (
                <Div
                    className={`cs-accordian ${selected === index ? 'active' : ''}`}
                    key={index}
                >
                    <Div
                        className="cs-accordian_head"
                        onClick={() => handelToggle(index)}
                    >
                        <h2 className="cs-accordian_title">{item.question}</h2>
                        <span className="cs-accordian_toggle cs-accent_color">
                            <svg
                                width={15}
                                height={8}
                                viewBox="0 0 15 8"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M0 0L7.5 7.5L15 0H0Z" fill="currentColor" />
                            </svg>
                        </span>
                    </Div>
                    {selected === index && (
                        <Div className="cs-accordian_body">
                            <Div className="cs-accordian_body_in">{item.answer}</Div>
                        </Div>
                    )}
                </Div>
            ))}
        </Div>
    );
};


const showcaseData = [
    {
        title: '',
        imgUrl: '/images/S1.JPG',
        // href: '/case-study/case-study-details',
    },
    {
        title: '',
        imgUrl: '/images/s5.png',
        // href: '/case-study/case-study-details',
    },
    {
        title: '',
        imgUrl: '/images/S2.JPG',
        // href: '/case-study/case-study-details',
    },
    {
        title: '',
        imgUrl: '/images/S4.png',
        // href: '/case-study/case-study-details',
    },
    {
        title: '',
        imgUrl: '/images/S3.JPG',
        // href: '/case-study/case-study-details',
    },
];


export default function ServiceDetailsPage() {
    pageTitle('Service Details');
    // const params = useParams();
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <>
            <Hero6
                heroSocialLinks={heroSocialLinks}
                socialLinksHeading="Follow Us"
                showcaseData={showcaseData}
            />

            <Spacing lg="150" md="80" />
            <Div className="container">
                <Div className="row align-items-center cs-column_reverse_lg">
                    <Div className="col-lg-5">
                        <Div className="cs-radius_15 cs-shine_hover_1">
                            <img
                                src="/images/about_img_5.jpeg"
                                alt="About"
                                className="cs-w100 cs-radius_5"
                            />
                        </Div>
                    </Div>
                    <Div className="col-lg-6 offset-lg-1">
                        <SectionHeading
                            title="Content That Captivates
<br/>& Converts"
                            subtitle="Bringing Story To Life"
                            btnText="Let's Create Magic Together"
                            btnLink="/contact"
                        />
                        <Spacing lg="0" md="24" />
                    </Div>
                </Div>
            </Div>
            {/* End About Section */}



            {/* <Spacing lg='145' md='80' /> */}
            {/* <Div className="container">
                <SectionHeading
                    title=''
                    subtitle=''
                    variant='cs-style1 text-center'
                /> */}
            {/* <Spacing lg='90' md='45' /> */}
            {/* </Div> */}

            <Spacing lg="70" md="45" />
            <ServiceList />

            <Spacing lg="90" md="70" />
            <PortfolioSlider2 />

            <Spacing lg='150' md='80' />
            <TestimonialSlider />
            <Spacing lg='145' md='80' />
            <Div className="container cs-shape_wrap_4">
                <Div className="cs-shape_4"></Div>
                <Div className="cs-shape_4"></Div>
                <Div className="container">
                    <Div className="row">
                        <Div className="col-xl-5 col-lg-6">
                            <SectionHeading
                                title='Some Pre Questions And Answers'
                                subtitle='FAQs/Resources'
                            />
                            <Spacing lg='90' md='45' />
                        </Div>
                        <Div className="col-lg-6 offset-xl-1">
                            <CustomAccordion />
                        </Div>
                    </Div>
                </Div>
            </Div>
            <Spacing lg='150' md='80' />
            <Div className="container">
                <Cta
                    title="Let&apos;s Build The <br />Next Big Thing Together! "
                    btnText='Your Next Big Move Starts Here!'
                    btnLink='/contact'
                    bgSrc='/images/cta_bg.jpeg'
                />
            </Div>
        </>
    )
}